export { default } from './svg/spacing-standard.svg';
